import React, { FC } from "react";
import { Control, useController } from "react-hook-form";

import FilterRangeBase, { FilterRangeBaseProps } from "@/components/ui/Form/Filters/components/Range/RangeBase";

export interface FilterRangeControlledProps extends FilterRangeBaseProps {
  control: Control;
}
const FilterRangeControlled: FC<FilterRangeControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });
  return <FilterRangeBase field={field} fieldState={fieldState} {...rest} />;
};
export default FilterRangeControlled;
